var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.fieldList.length)?_c('client-detail',{attrs:{"id":_vm.order['client']['id'],"fieldList":_vm.fieldList,"changeItem":false},on:{"input":_vm.save}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }